module.exports = __webpack_public_path__ + "static/img/020_2.5d1669a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/020_2.jpg
// module id = RgEs
// module chunks = 1